function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.34 6.34a1.11 1.11 0 00-1.572 1.567l.976.982h-8.8a1.111 1.111 0 000 2.222h8.8l-.972.972a1.112 1.112 0 001.572 1.573l2.917-2.917a1.045 1.045 0 000-1.478l-2.92-2.92zM2.222 2.222H8.89a1.111 1.111 0 100-2.222H2.222C1 0 0 1 0 2.222v15.556C0 19 1 20 2.222 20H8.89a1.111 1.111 0 000-2.222H2.222V2.222z",
  fill: "#3B3B3B"
});

var SvgLogout = function SvgLogout(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M16.3401 6.34013C15.9068 5.90682 15.2043 5.90682 14.771 6.34012C14.3386 6.77246 14.3375 7.47308 14.7685 7.90678L15.7444 8.88889H6.94445C6.3308 8.88889 5.83333 9.38635 5.83333 10C5.83333 10.6136 6.33079 11.1111 6.94444 11.1111H15.7444L14.7722 12.0833C14.3392 12.5164 14.3379 13.2182 14.7695 13.6528C15.2032 14.0895 15.9092 14.0908 16.3444 13.6556L19.2614 10.7386C19.6693 10.3307 19.6693 9.66933 19.2614 9.26144L16.3401 6.34013ZM2.22222 2.22222H8.88889C9.50254 2.22222 10 1.72476 10 1.11111C10 0.497462 9.50254 0 8.88889 0H2.22222C1 0 0 1 0 2.22222V17.7778C0 19 1 20 2.22222 20H8.88889C9.50254 20 10 19.5025 10 18.8889C10 18.2752 9.50254 17.7778 8.88889 17.7778H2.22222V2.22222Z' fill='%233B3B3B'/%3E %3C/svg%3E";
export { SvgLogout as ReactComponent };